import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  InternalAdminEditUserMutation,
  InternalAdminEditUserMutationVariables,
  InternalAdminUserFragment,
  UserRoleType,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import INTERNAL_ADMIN_EDIT_USER_MUTATION from "../_networking/internal-admin-edit-user";

interface IProps {
  user: InternalAdminUserFragment;
}

const InternalAdminEditUserAdmin = ({ user }: IProps) => {
  const [internalAdminEditUserMutationAPI] = useMutation<
    InternalAdminEditUserMutation,
    InternalAdminEditUserMutationVariables
  >(INTERNAL_ADMIN_EDIT_USER_MUTATION);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      internalAdminEditUserMutationAPI({
        variables: {
          organizationId: user.organizationId,
          id: user.id,
          input: {
            roleType:
              e.target.checked === true
                ? UserRoleType.Admin
                : UserRoleType.User,
          },
        },
        fetchPolicy: "network-only",
      });
    },
    [internalAdminEditUserMutationAPI, user],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={user.roleType === UserRoleType.Admin}
      onChange={onChange}
    />
  );
};

export default memo(InternalAdminEditUserAdmin);
